module.exports = __webpack_public_path__ + "static/media/kvn.43762d8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/kvn.svg
// module id = 386
// module chunks = 7